import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { OutletType } from "@/app/services/generated/outlettypeService";
import { outletTypeService } from "@/app/services/generated/outlettypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasOutletTypesCache {
  outletTypes: OutletTypesCache;
}

// Singleton cache store
const outletTypesCacheStore = new EntityCacheStore<OutletType>(
  EnumCacheEntityType.outletType,
  async () => outletTypeService.getAllOutletTypes()
);

// Ephemeral reader
export default class OutletTypesCache extends EntityWithGuidKeyCache<OutletType> {
  constructor() {
    super(outletTypesCacheStore, (x) => x.id);
  }
}
